import React from "react";
import { CircleCheck } from "lucide-react";
import PandaStoIsWatching from "../../../assets/PandaStoIsWatching.png";

// Sidebar Component
const Sidebar = ({
  stories,
  currentStoryId,
  completedStories,
  onStorySelect,
  isOpen,
  onToggle,
}) => {
  const canAccessStory = (storyId) => {
    // Can access if story is completed or is the current story
    return completedStories.includes(storyId) || storyId === currentStoryId;
  };

  return (
    <>
      {/* Mobile Menu Button */}
      <button
        onClick={onToggle}
        className="lg:hidden fixed top-4 left-1 z-50 p-2 bg-white rounded-md shadow-md mt-12"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>

      {/* Sidebar Overlay for Mobile */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={onToggle}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed lg:static lg:translate-x-0 top-0 left-0 h-full w-80 bg-gray-50 shadow-lg transform transition-transform duration-300 ease-in-out z-40 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Stories List */}
          <div className="flex-1 overflow-y-auto flex flex-col gap-4 py-8 px-6 mt-24 sm:mt-0">
            {stories.map((story, index) => {
              const isCompleted = completedStories.includes(story.id);
              const isCurrent = story.id === currentStoryId;
              const canAccess = canAccessStory(story.id);

              return (
                <div
                  key={story.id}
                  onClick={() => canAccess && onStorySelect(story.id)}
                  className={`flex items-center py-3 transition-colors duration-200 rounded-xl px-2 ${
                    canAccess
                      ? "cursor-pointer hover:bg-gray-100"
                      : "cursor-not-allowed opacity-50"
                  } ${isCurrent ? "bg-[#FFFFFF] rounded-xl" : ""}`}
                >
                  {/* Status Icon */}
                  <div className="flex-shrink-0 mr-3">
                    {isCompleted ? (
                      <div className="w-6 h-6 bg-[#54B0AF] rounded-full flex items-center justify-center">
                        <svg
                          className="w-3 h-3 text-white"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    ) : isCurrent ? (
                      <CircleCheck className="text-[#323232]" />
                    ) : (
                      <CircleCheck className="text-[#AAAAAA]" />
                    )}
                  </div>

                  {/* Story Title */}
                  <div className="flex-1">
                    <h3
                      className={`text-sm sm:text-base font-gotham font-medium ${
                        isCompleted || isCurrent
                          ? "text-[#323232]"
                          : "text-[#AAAAAA]"
                      }`}
                    >
                      {story.title}
                    </h3>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Panda Character Container */}
          <div className="p-6">
            <div className="bg-[#54B0AF] rounded-[20px] text-white">
              <div className="flex items-center">
                {/* Left text section */}
                <div className="w-2/3 pr-4 p-4">
                  <p className="font-bold font-gotham text-base sm:text-xl text-[#FFFFFF] mb-2">
                    Sto is watching.
                  </p>
                  <p className="text-sm sm:text-base font-gotham font-medium text-[#F5F5F5] leading-5">
                    Sto will track your answers and decode your corporate self.
                  </p>
                </div>
                {/* Right image section */}
                <div className="w-1/3 h-[180px] relative overflow-hidden rounded-[16px]">
                  <img
                    src={PandaStoIsWatching}
                    alt="Sto Panda"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
